import { ChevronDownIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { NavItem } from "config/navigation";
import {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
} from "lib/headlessui/components/menu/menu";
import React from "react";
import { Link } from "./link";

interface NavbarOverflowMenuProps {
    items: NavItem[];
}

export const NavbarOverflowMenu: React.FC<NavbarOverflowMenuProps> = ({ items }) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <Menu as="div" className="relative">
            <MenuButton className="relative flex cursor-pointer items-center gap-1 rounded-lg p-2 text-left text-base/6 font-medium text-zinc-950 data-[hover]:bg-zinc-950/5 sm:text-sm/5 dark:text-white dark:data-[hover]:bg-brand-950/30">
                More
                <span aria-hidden="true">· {items.length}</span>
                <ChevronDownIcon className="size-4" />
            </MenuButton>
            <MenuItems
                anchor="bottom end"
                className="z-1300 w-56 rounded-md bg-white py-1 shadow-lg ring-1 ring-gray-200 ring-opacity-5 focus:outline-none [--anchor-gap:0.25rem] dark:bg-zinc-800 dark:ring-white/10">
                {items.map(item => (
                    <MenuItem key={item.url}>
                        {({ focus }) => (
                            <Link
                                href={item.url}
                                className={clsx(
                                    "block px-4 py-2 text-sm",
                                    focus
                                        ? "bg-brand-100 text-brand-900 dark:bg-brand-950/30 dark:text-white"
                                        : "text-zinc-700 dark:text-zinc-200",
                                )}>
                                {item.label}
                            </Link>
                        )}
                    </MenuItem>
                ))}
            </MenuItems>
        </Menu>
    );
};
